import React from 'react';
import Loadable from 'react-loadable';

const Map = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<div />),
  delay: 1000,
});

export default Map;
